module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/onesence-2-28098b23f6591c37c97de393e768afdf.webp";